import type { SVGProps } from 'react';
import * as React from 'react';

/* AUTOGENERATED: DO NOT EDIT */
import _styles from '../logo.module.css';
export const SlackIcon = (props: SVGProps<SVGSVGElement>): JSX.Element => (
  <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} fill="none" {...props}>
    <path
      fill="#fff"
      d="M4.8 12.38a1.89 1.89 0 1 1-1.9-1.9h1.9zm.94 0a1.89 1.89 0 1 1 3.78 0v4.73a1.89 1.89 0 1 1-3.78 0zM7.63 4.78A1.89 1.89 0 1 1 9.52 2.9v1.9zm0 .96a1.89 1.89 0 1 1 0 3.79H2.89a1.89 1.89 0 1 1 0-3.79zM15.2 7.64a1.89 1.89 0 1 1 1.9 1.89h-1.9zm-.94 0a1.89 1.89 0 1 1-3.78 0V2.89a1.89 1.89 0 1 1 3.78 0zM12.37 15.22a1.89 1.89 0 1 1-1.89 1.89v-1.9zm0-.95a1.89 1.89 0 1 1 0-3.78h4.74a1.89 1.89 0 1 1 0 3.78z"
    />
  </svg>
);
